module.exports = __webpack_public_path__ + "static/media/add_member.6af1d480.svg";